/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useState} from 'react';
import {animate, motion, useMotionValue} from "motion/react";


function Kpi({title, value, className, duration = 0.5, unit}) {
    // motion value that holds a numeric, animatable value
    const motionValue = useMotionValue(value);
    const [displayValue, setDisplayValue] = useState(Math.round(value));

    useEffect(() => {
        // animate motionValue from its current to new `value`
        const controls = animate(motionValue, value, {
            duration,
            ease: "easeOut",
            onUpdate: (latest) => {
                setDisplayValue(Math.round(latest));
            },
        });

        return () => {
            controls.stop();
        };
    }, [value, duration, motionValue]);

    return (
        <div className="overflow-hidden ">
            <dt className="truncate text-sm font-medium text-stone-500 tracking-wider uppercase">{title}</dt>
            <dd className={`mt-1 text-xl font-normal text-gray-900 proportional-nums ${className}`}>
                <motion.span>{displayValue}</motion.span>
                {unit}
            </dd>
        </div>
    );
}


export default Kpi;